import React, { useState, useEffect, useContext } from "react";
import paginationFactory, {
	PaginationProvider,
} from "react-bootstrap-table2-paginator";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import axios from "axios";
import "../../stylesheets/resource.scss";
import { tableStyle } from "../../ticketModule/variables/ListingVariables";
import Header from "../../timesheetModule/Header";
import CreateDesignation from "./CreateDesignation";
import { Designation_API } from "./designationAPIs";
import { UserContext } from "../../../UserContext";
import { Table } from "../../../components/CustomPaginations";
import Delete from "../../../images/delete.svg";
import { AlertPopups } from "../../../components/AlertPopups";
import moment from "moment";

export const Designation = () => {
	const defaultSorted = [
		{
			dataField: "designationId",
			order: "aesc",
		},
	];

	const userDetails = useContext(UserContext);
	const [designation, setDesignation] = useState([]);
	const [loading, setLoading] = useState(true);
	const [sortBy, setSortBy] = useState(defaultSorted[0]);
	const [numberOfItemsPerPage, setNumberOfItemsPerPage] = useState(10);
	const [pagerData, setPagerData] = useState(null);
	const [isRerender, setIsRerender] = useState(false);

	const headers = {
		Authorization: `Bearer ${userDetails.token}`,
	};
	useEffect(() => {
		axios.get(Designation_API.GetDesignationList, headers).then((res) => {
			setPagerData(JSON.parse(res.headers["x-pagination"]));
			setDesignation(res.data.designations);
			setLoading(false);
		});
	}, [isRerender]);

	const column = [
		{
			dataField: "designationId",
			text: "ID",
			sort: true,
			headerStyle: {
				width: "15%",
			},
		},
		{
			dataField: "designationName",
			text: "Designation Title",
			sort: true,
		},
		{
			dataField: "createdBy",
			text: "Created By",
			sort: true,
		},
		{
			dataField: "createdAt",
			text: "Created At",
			sort: true,
			formatter: (cell, row) => {
				return row.createdAt ? (
					<span>{moment(row?.createdAt).format("DD/MM/YY")}</span>
				) : (
					<span>N/A</span>
				);
			},
		},
		{
			dataField: "updatedBy",
			text: "Updated By",
			sort: true,
		},
		{
			dataField: "updatedAt",
			text: "Updated At",
			sort: true,
			formatter: (cell, row) => {
				return row.updatedAt ? (
					<span>{moment(row?.updatedAt).format("DD/MM/YY")}</span>
				) : (
					<span>N/A</span>
				);
			},
		},
		{
			dataField: "action",
			text: "Action",
			formatter: (cell, row) => {
				return (
					<div
						style={{ textAlign: "center" }}
						onClick={() => {
							axios
								.delete(
									`${Designation_API.CreateDesignation}/${row.designationId}`,
									{
										headers,
									}
								)
								.then((res) => {
									if (res.status === 200) {
										setIsRerender(!isRerender);
									}
								});
						}}
					>
						<img
							style={{ height: "20px", width: "20px" }}
							src={Delete}
							alt="Edit"
							title="Modify Category"
						/>
					</div>
				);
			},
		},
	];

	const handleTableChange = (type, { page, sortOrder, sortField }) => {
		setLoading(true);
		let apiURL = "";
		if (type === "sort") {
			apiURL = `${Designation_API.GetDesignationList}?PageNumber=${page}&PageSize=${numberOfItemsPerPage}&SortBy=${sortField}_${sortOrder}`;
			setSortBy({ dataField: sortField, order: sortOrder });
		} else {
			apiURL = `${Designation_API.GetDesignationList}?PageNumber=${page}&PageSize=${numberOfItemsPerPage}`;
		}

		if (page) {
			axios
				.get(apiURL, {
					headers: { Authorization: `Bearer ${userDetails.token}` },
				})
				.then((res) => {
					setLoading(false);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setDesignation(res.data.designations);
				})
				.catch((err) => {
					if (err.response) {
						AlertPopups.ErrorAlert.fire({
							text: `${err.response.data.message} `,
						});
					}
				});
		}
	};

	const receiveData = (PageSize) => {
		setLoading(true);
		let apiURL = "";
		apiURL = `${
			Designation_API.GetDesignationList
		}?PageNumber=${1}&PageSize=${PageSize} `;
		axios
			.get(apiURL, {
				headers: { Authorization: `Bearer ${userDetails.token} ` },
			})
			.then((res) => {
				setLoading(false);
				setNumberOfItemsPerPage(PageSize);
				setPagerData(JSON.parse(res.headers["x-pagination"]));
				setDesignation(res.data.designations);
			})
			.catch((err) => {
				if (err.response) {
					AlertPopups.ErrorAlert.fire({
						text: `${err.response.data.message} `,
					});
				}
			});
	};

	return (
		<React.Fragment>
			<div className="container-fluid pl-2 ">
				<Header title={"Manage Designation"} />

				<CreateDesignation />
				<PaginationProvider
					pagination={paginationFactory({
						custom: true,
						totalSize: designation.length,
						page: pagerData?.CurrentPage,
						sizePerPage: pagerData?.PageSize,
						paginationSize: pagerData?.PageSize,
					})}
				>
					{({ paginationProps, paginationTableProps }) => {
						return (
							<Table
								inputValue={""}
								keyField={"designationId"}
								columns={column}
								items={designation}
								tableStyle={tableStyle}
								paginationProps={paginationProps}
								paginationTableProps={paginationTableProps}
								onTablePageChange={handleTableChange}
								defaultSorted={sortBy}
								pagerData={pagerData}
								showFeedback={false}
								tableLoader={loading}
								SearchBar={() => {
									return null;
								}}
								receiveData={(PageSize) => {
									receiveData(PageSize);
								}}
								adminPagination={userDetails.empRole.includes(
									"3"
								)}
							/>
						);
					}}
				</PaginationProvider>
			</div>
		</React.Fragment>
	);
};

export default Designation;
